import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ca92f36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo-container" }
const _hoisted_2 = { class: "right-container" }
const _hoisted_3 = { class: "right-block" }
const _hoisted_4 = { class: "meaning-image animate__flipInX wow" }
const _hoisted_5 = {
  src: "",
  alt: ""
}
const _hoisted_6 = {
  "data-wow-duration": "1s",
  class: "techcontext animate__fadeInUp wow"
}
const _hoisted_7 = {
  "data-wow-duration": "1s",
  class: "teamtitle animate__fadeInDown wow"
}
const _hoisted_8 = { class: "span" }
const _hoisted_9 = {
  "data-wow-duration": "1s",
  class: "teamtitle animate__fadeInDown wow"
}
const _hoisted_10 = { class: "span" }
const _hoisted_11 = { class: "left-container" }
const _hoisted_12 = { class: "left-block" }
const _hoisted_13 = {
  "data-wow-duration": "1s",
  class: "teamtitle animate__fadeInDown wow"
}
const _hoisted_14 = {
  "data-wow-duration": "1s",
  class: "techcontext animate__fadeInUp wow"
}
const _hoisted_15 = { class: "span" }
const _hoisted_16 = { class: "span" }
const _hoisted_17 = { class: "meaning-image animate__flipInX wow" }
const _hoisted_18 = {
  src: "",
  alt: ""
}

import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutLogo',
  setup(__props) {

const isHover = ref(false)
onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})


return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
            [_directive_lazy, require('@/assets/about-rekey2.jpg')]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('RE')), 1)
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('logolefttext')), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('KEY')), 1)
          ]),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('logorighttext')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('subRekeytitle')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('meaningRekey')), 1),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('logobottomtext')), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [
            [_directive_lazy, require('@/assets/about-rekey1.jpg')]
          ])
        ])
      ])
    ])
  ]))
}
}

})